import * as comments from "./comments";
import * as header from "./header";
import * as hero from "./hero";
import * as program from "./program";
import * as konami from "./konami";
import * as contentCard from "./contentCard";
import * as stats from "./stats";
import * as lightbox from "./lightbox";

header.setup();
hero.setup();
comments.setup();
program.setup();
konami.setup();
contentCard.setup();
stats.setup();
lightbox.setup();
